import { render, staticRenderFns } from "./Datim.vue?vue&type=template&id=06abffa0&"
import script from "./Datim.vue?vue&type=script&lang=ts&"
export * from "./Datim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports